module.exports = __webpack_public_path__ + "static/media/noImage.aa28a602.png";